// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const rotom_mow: PokeData = {
  "id": 10012,
  "name": "rotom-mow",
  "height": 3,
  "weight": 3,
  "base_experience": 182,
  "types": [
    PokeType.ELECTRIC,
    PokeType.GRASS
  ],
  "api_moves": [
    "thunder-shock",
    "thunder-wave",
    "double-team",
    "confuse-ray",
    "substitute",
    "uproar",
    "charge",
    "trick",
    "astonish",
    "shock-wave",
    "discharge",
    "ominous-wind",
    "electro-ball",
    "hex"
  ],
  "moves": [
    "thunder-shock",
    "confuse-ray",
    "grassy-terrain",
    "leaf-tornado",
    "wood-hammer",
    "quick-tempo",
    "vine-whip",
    "electric-wrath",
    "thunder-fang",
    "flower-rush",
    "power-whip",
    "synthesis",
    "branch-poke"
  ],
  "evolution_chain": {
    "id": 240,
    "item": null,
    "species": [
      {
        "name": "rotom",
        "order": 480,
        "types": [
          PokeType.ELECTRIC,
          PokeType.GHOST
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 117,
    "speed": 128,
    "ability_power": 156
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
